import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';

export const getFundamentos = async () => {
  try {
    const response = await API.get('/configuracion/fundamentos-legales/');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const getVisitaDomiciliaria = async (id) => {
  try {
    const response = await API.get(`/tramites/tipos-de-visitas-domiciliarias/${id}/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const createVisitaDomiciliaria = async (data) => {
  try {
    const response = await API.post('/tramites/tipos-de-visitas-domiciliarias/', data);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};
